<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          โครงการหลัก
        </div>
        <div class="d-flex align-center font-type-bold txt-head black--text">
          <Iconify
              icon="ion:cube"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          โครงการที่เปิดรับ
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 190px">
            <div>สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end">
          <Button
              @onClick="createProject"
          >
            สร้างโครงการ
          </Button>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <MainProjectItem
            v-for="(item, i) in plans"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></MainProjectItem>
      </div>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import MainProjectItem from "../../components/MainProjectItem"

export default {
  name: "MainProject",
  components: {
    TextField,
    SelectBox,
    MainProjectItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการหลัก',
          width: '60%'
        },
        {
          name: 'สถานะ',
          width: '20%'
        }
      ],
      plans: []
    }
  },
  created () {
    this.getProjects()
  },
  methods: {
    createProject () {
      this.$router.push({ name: 'MainProjectForm' })
    },
    async getProjects () {
      let res = await this.$apiFire('MainProject/getMainProjects')
      console.log(res)
      this.plans = res
    }
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>